/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIUserRole
 */
export interface APIUserRole {
    /**
     * 
     * @type {string}
     * @memberof APIUserRole
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIUserRole
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIUserRole
     */
    isGuestUserRole?: boolean;
}

/**
 * Check if a given object implements the APIUserRole interface.
 */
export function instanceOfAPIUserRole(value: object): value is APIUserRole {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIUserRoleFromJSON(json: any): APIUserRole {
    return APIUserRoleFromJSONTyped(json, false);
}

export function APIUserRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIUserRole {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'isGuestUserRole': json['is_guest_user_role'] == null ? undefined : json['is_guest_user_role'],
    };
}

export function APIUserRoleToJSON(value?: APIUserRole | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'is_guest_user_role': value['isGuestUserRole'],
    };
}

